import {AdminUserAlert, PageTitle} from "../_components";
import {Link, useParams} from "react-router-dom";
import {useAuth} from "../../context";
import {useGetJson, usePostJson} from "../../hooks";
import {endpoints} from "../../utils2";
import {Alert, Button, Stack,} from "react-bootstrap";
import {WhiteCard} from "./_components/WhiteCard";
import {ABBreadcrumbs} from "./_components/ABBreadcrumbs";
import {
    AnnouncementSection,
    CodecSection,
    ConnectionSection,
    DeviceSection,
    LiveControlSection,
    NetworkSection,
    NextSection,
    OnlineSection,
    StreamSection,
    ThirdPartySection
} from "./dashboard";
import {SSEProvider, SseTopics} from "../../context/SSEContext";
import {useTopicSSE} from "../../hooks/useTopicSSE";
import {FirmwareProgressBar} from "./dashboard/FirmwareProgressBar";
import {NextControlSection} from "./dashboard/NextControlSection";
import {useMemo} from "react";


export function DashboardDevice() {
    const {authToken} = useAuth()
    const {uid, did} = useParams()

    return <SSEProvider url={endpoints.push.allFields(uid, did, authToken.jwt)}>
        <Dashboard/>
    </SSEProvider>
}


function Dashboard() {
    const {uid, did} = useParams()
    const {authToken} = useAuth()

    const [deviceData, loadingDevice, errorDevice, clearErrorDevice] = useGetJson(endpoints.device.get(uid, did), authToken?.jwt)
    const device = deviceData?.data

    const online = useTopicSSE(SseTopics.Online)
    const dev = useTopicSSE(SseTopics.Device)
    const upgrade = useTopicSSE(SseTopics.Upgrade)

    const [rebootPush, rebootValue, rebootLoadingPush, rebootErrorPush, clearRebootErrorPush] = usePostJson(endpoints.push.reboot(uid, did), authToken?.jwt)

    function handleInstall() {
        console.log("Installing...")
        rebootPush({reboot: true, upgrade: true})
    }

    const toConfigure = `/device/${uid}`

    const showFirmAlert = useMemo(() => {
        if (dev?.LFW?.includes(".") && dev?.firm?.includes(".")) {
            const LFW_parts = dev.LFW.split(".")
            const firm_parts = dev.firm.split(".")
            return ((Number(LFW_parts[0]) > Number(firm_parts[0])) || (Number(LFW_parts[0]) === Number(firm_parts[0]) && Number(LFW_parts[1]) > Number(firm_parts[1])));
        }
        return false;
    }, [dev])

    return <>
        <AdminUserAlert/>
        <Alert variant="danger" show={errorDevice} dismissible onClose={clearErrorDevice}>{errorDevice}</Alert>

        <ABBreadcrumbs breadcrumbList={[
            {name: "Your devices", shortName: "Devices", to: `/device/${uid}`},
            {name: "Configure Device", shortName: "Configure", to: `/device/${uid}/${did}/config`},
            {name: "Dashboard"}]}
        />

        <PageTitle title={device?.name}></PageTitle>

        {dev?.LFW && online &&
            <Alert variant="danger" show={showFirmAlert} className="p-2">
                <div className="d-flex flex-column">
                    <div className="d-flex align-items-center">
                        <i className="bi bi-info-circle me-2 fs-4"/>
                        <div className="fw-semibold fs-5">Firmware {dev.LFW} update available!</div>
                    </div>
                    <div>Download and install the latest firmware now to enhance performance and security.<br/>
                        <i className="bi bi-exclamation-triangle fs-5 me-2"/>{device?.name} will <strong>automatically reboot</strong> during installation.
                    </div>
                </div>
                <div className="d-flex align-items-center gap-2">
                    <div><Button variant="danger" className="mt-2" onClick={handleInstall} disabled={upgrade?.state === 1 || upgrade?.state === 4 || upgrade?.state === 5}>Update</Button></div>
                    {upgrade?.state === 1 && <div>Rebooting...</div>}
                </div>
                {(upgrade?.state === 4 || upgrade?.state === 5) && <FirmwareProgressBar state={upgrade?.state} tar={upgrade?.tar} rec={upgrade?.rec}/>}
                {/*{JSON.stringify(upgrade)}*/}
            </Alert>
        }

        <div className="d-flex flex-wrap justify-content-between gap-2">
            <OnlineSection device={device}/>
            <ConnectionSection device={device}/>
            {/*<NextSection device={device}/>*/}
            {/*<ThirdPartySection/>*/}
            <NextControlSection device={device}/>
            <AnnouncementSection/>
        </div>

        {/*<WhiteCard>*/}
        {/*    <LiveControlSection device={device}/>*/}
        {/*</WhiteCard>*/}

        <div className="d-flex flex-wrap gap-2">
            <StreamSection device={device}/>
            <CodecSection device={device}/>
        </div>

        <div className="d-flex flex-wrap gap-2">
            <DeviceSection device={device}/>
            <NetworkSection/>
        </div>

        <Stack direction="horizontal" gap="2" className="py-3 justify-content-end">
            <Button as={Link} variant="link" to={toConfigure}>Go back</Button>
        </Stack>
    </>
}


export const stateMap = {
    0: "Unknown",
    1: "Starting",
    2: "Started",
    3: "Stopping",
    4: "Stopped",
    5: "Failed"
}

export const nextMap = [
    {id: 0, status: "No event"},
    {id: 1, status: "Stopped"},
    {id: 2, status: "Scheduled"},
    {id: 3, status: "Running"},
]

export const firmwareMap = {
    0: "Nothing",
    1: "Reboot",
    2: "OTA started",
    3: "OTA timeout",
    4: "OTA receiving",
    5: "OTA completed"
}
